import React, { Component } from 'react'
/**
 * 列定义
 */
export interface DefCol {
    /** 是否是过滤列，过滤列会有列选择 */
    isFilterCol?: boolean,
    /** 是否显示 */
    isShow?: string | boolean,
    /** 是否固定 left | right */
    fixed?: string | boolean,
    /** 列名 */
    fieldName: string,
    /** 列编号 */
    fieldCode: string,
    /** id */
    id?: string,
    /** 是否隐藏 */
    hidden?: boolean,
    /**
     * antd 属性
     * 排序函数，本地排序使用一个函数(参考 Array.sort 的 compareFunction)，
     * 如果不传会采用如下默认的 sorter 函数
     * ``` 
       function (a, b, sortDirection) {
            let valuea = a[this.fieldCode];
            let valueb = b[this.fieldCode];
            if (valuea != undefined && valueb != undefined) {
                return valuea.localeCompare(valueb)
            } else if (valuea == undefined) {
                return 1;
            } else if (valueb == undefined) {
                return -1;
            }
        },
        ```
     * 需要服务端排序可设为 true	
     */
    sorter?: ((a, b, sortDirection) => number) | boolean,
    /**
     * antd 属性
     * 支持的排序方式，取值为 'ascend' 'descend'	
     * ['ascend', 'descend']
     */
    sortDirections?: Array<string>
    /** 其他 */
    [key: string]: any
}

/**
 * 动态表格列定义，兼容antd表格列定义所有参数
 */
export default class ColDef extends Component<DefCol> {
    render() {
        return (
            <div>

            </div>
        )
    }
}
